<template>
  <div class="events">
    <template v-if="tableItems.length">
      <AppTable
        :fields="tableFields"
        :items="tableItems"
        @sort="onSortTable"
      >
        <template #title="data">
          <BaseLink :href="`/events/${data.id}`">
            {{ data.title }}
          </BaseLink>
        </template>
      </AppTable>
      <div
        v-if="(paginationTotal / paginationPerPage) > 1"
        class="events__pagination-wrapper"
      >
        <AppPagination
          v-model="paginationCurrent"
          :totalRows="paginationTotal"
          :perPage="paginationPerPage"
        />
      </div>
    </template>
    <p v-else class="h3">Список событий пуст.</p>
  </div>
</template>

<script>
import AppTable from '@/components/AppTable'
import AppPagination from '@/components/Base/AppPagination'
import BaseLink from '@/components/Base/BaseLink'

export default {
  name: 'AppEvents',
  components: {
    BaseLink,
    AppPagination,
    AppTable
  },
  data () {
    return {
      tableFields: [
        {
          key: 'title',
          label: 'Название события',
          sortable: true,
          slot: true
        },
        {
          key: 'createdBy',
          label: 'Создатель',
          sortable: true,
          slot: false
        },
        {
          key: 'start',
          label: 'Начало',
          sortable: true,
          slot: false
        },
        {
          key: 'gameLevel',
          label: 'Уровень игры',
          sortable: true,
          slot: false
        },
        {
          key: 'privacy',
          label: 'Приватность',
          sortable: true,
          slot: false
        },
        {
          key: 'status',
          label: 'Статус',
          sortable: true,
          slot: false
        }
      ],
      tableItems: [],
      paginationCurrent: 1,
      paginationTotal: 1,
      paginationPerPage: 10,
      order: 'DESC',
      sort: 'start'
    }
  },
  computed: {
    requestBody () {
      return {
        id: this.$route.params.id,
        pageSize: this.paginationPerPage,
        currentPage: this.paginationCurrent,
        searchBy: this.searchValue,
        sort: this.sort,
        order: this.order
      }
    }
  },
  watch: {
    /** Отслеживанию изменение св-ва и подтягиваю новые данные таблицы */
    paginationCurrent: 'fetchEvents'
  },
  created () {
    this.fetchEvents()
  },
  methods: {
    async fetchEvents () {
      try {
        const { data } = await this.$api.field.events(this.requestBody)
        const items = data?.list ?? []

        /* Записал общее колво событий */
        this.paginationTotal = data.pages * this.paginationPerPage

        this.tableItems = items.map(item => {
          return {
            id: item.id,
            title: item.title,
            createdBy: item.createdBy?.name,
            start: item.start,
            gameLevel: item.gameLevel,
            privacy: item.privacy,
            status: item.status
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    /**
     * Записал новые значения сортировки
     */
    onSortTable (event) {
      this.sort = event.key
      this.order = event.by.toUpperCase()
      this.fetchEvents()
    }
  }
}
</script>

<style lang="scss" scoped>
.events {
  &__pagination-wrapper {
    margin-top: 20px;
    text-align: right;
  }
}
</style>
